import { observer } from "mobx-react-lite";
import SearchStore from "core/stores/search.store";

type NoSearchResultsProps = {
  store: SearchStore;
}

const NoSearchResults = observer<NoSearchResultsProps>(({store}) => {
  return <ul className="search-results">
    <li>
      <h6>No results for {store.city}</h6>
    </li>
  </ul>;
});

export default NoSearchResults;
